import { render, staticRenderFns } from "./ApiDocumentation.vue?vue&type=template&id=084dc7d2&scoped=true&"
import script from "./ApiDocumentation.vue?vue&type=script&lang=js&"
export * from "./ApiDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ApiDocumentation.vue?vue&type=style&index=0&id=084dc7d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084dc7d2",
  null
  
)

export default component.exports